module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role.description),
      expression: "role.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.role.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.role, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Grupos Filhos")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "label": "description",
      "track-by": "objectId",
      "multiple": true,
      "show-labels": false,
      "allow-empty": false,
      "options": _vm.options,
      "placeholder": "Selecione um ou mais grupos"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', [_vm._v("Usuários Diponíveis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Filtrar"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getAdditionalInfo.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftSelected),
      expression: "leftSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "10",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user
      }
    }, [_vm._v(_vm._s(user.name) + " ("), (user.username) ? _c('span', [_vm._v(_vm._s(user.username))]) : _c('span', [_vm._v("<Sem Identificação>")]), _vm._v(")")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('ul', {
    staticClass: "picklist-control"
  }, [_c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Adicionar selecionados"
    },
    on: {
      "click": function($event) {
        return _vm.addSelected()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-forward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Adicionar todos"
    },
    on: {
      "click": function($event) {
        return _vm.addAll()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-fast-forward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Remover selecionados"
    },
    on: {
      "click": function($event) {
        return _vm.removeSelected()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-backward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Remover todos"
    },
    on: {
      "click": function($event) {
        return _vm.removeAll()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-fast-backward"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', [_vm._v("Usuários Vinculados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterFinal),
      expression: "filterFinal"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Filtrar"
    },
    domProps: {
      "value": (_vm.filterFinal)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getRoleAndAdditionalInfo(_vm.id)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterFinal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightSelected),
      expression: "rightSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "10",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.finalUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user
      }
    }, [_vm._v(_vm._s(user.name) + " ("), (user.username) ? _c('span', [_vm._v(_vm._s(user.username))]) : _c('span', [_vm._v("<Sem Identificação>")]), _vm._v(")")])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Salvar\n      ")]), _vm._v(" "), (_vm.role.objectId) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("\n        Excluir\n      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/groups"
    }
  }, [_vm._v("Cancelar")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b718d2aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupDetail.vue
// module id = 1468
// module chunks = 1